<template>
  <section class="section">
    <BaseForm
      ref="baseForm"
      :title="$t('models.auth.resetPassword')"
      :data-object="passwordResetRequest"
      :content-type="'request-reset-password'"
      :custom-submit="true"
      :on-custom-submit="enterKey"
      :has-error="!passwordsMatch"
      :error-message="errorMessage"
      :column-width="'is-one-third is-offset-4'"
    >
      <template #content>
        <v-text-field
          v-model.trim="passwordResetRequest.username"
          :disabled="activation"
          label="Benutzername"
          class="field"
          name="username"
          value=""
          color="primary"
          required
        />

        <v-text-field
          v-if="!activation"
          v-model="passwordResetRequest.password1"
          :label="$t('models.auth.newPassword')"
          :disabled="activation"
          class="field"
          name="password1"
          type="password"
          value=""
          required
          password-reveal
          color="primary"
          placeholder=""
        />

        <v-text-field
          v-if="!activation"
          v-model.trim="passwordResetRequest.password2"
          :label="$t('models.auth.repeatPassword')"
          class="field"
          name="password2"
          type="password"
          value=""
          required
          color="primary"
          password-reveal
        />

        <v-alert v-if="!activation" :closable="false" type="info">
          {{ $t('models.auth.emailPinInfo') }}
        </v-alert>
        <v-text-field
          v-if="activation"
          v-model.trim="passwordReset.pin"
          :label="$t('models.auth.pinFromEmail')"
          class="field"
          name="ping"
          color="primary"
          value=""
          required
        />
      </template>
    </BaseForm>
  </section>
  <LoadingOverlay v-model:loading="loading" />
</template>

<script setup lang="ts">
import axios from 'axios'
import { computed, onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'

import { apiClient } from '@/api/ApiClient'
import BaseForm from '@/components/common/BaseForm.vue'
import LoadingOverlay from '@/components/common/LoadingOverlay.vue'
import { i18n } from '@/lang/setup'
const passwordResetRequest = ref({
  username: '',
  email: '',
  password1: '',
  password2: '',
})
const passwordReset = ref({
  username: '',
  nonce: '',
  pin: '',
})
const errorMessage = ref('')
const router = useRouter()
const store = useStore()

const isPasswordsMatch = ref(true)
const loading = ref(false)
const baseForm = ref(null)

const requestResetPassword = async () => {
  loading.value = true
  passwordResetRequest.value.email = passwordResetRequest.value.username
  try {
    const response = await apiClient.requestResetPassword(
      passwordResetRequest.value
    )
    baseForm.value.clearError()
    passwordReset.value.nonce = response.data.nonce
    passwordReset.value.username = response.data.profile
  } catch (error) {
    baseForm.value.handleError(error)
  }
  loading.value = false
}

const resetPassword = async () => {
  loading.value = true
  try {
    const response = await apiClient.resetPassword(passwordReset.value)
    router.push({ name: 'login' })
  } catch (error) {
    passwordReset.value.nonce = ''
    passwordReset.value.pin = ''
    baseForm.value.handleError(error)
  }
  loading.value = false
}

const enterKey = () => {
  if (!activation.value) {
    requestResetPassword()
  } else {
    resetPassword()
  }
}

onMounted(() => {
  axios
    .post(
      '/api/v1/auth/logout',
      {
        user: {
          id: store.state.global.profileId,
          is_authenticated: store.state.global.is_authenticated,
        },
      },
      store.state.global.axiosConfig
    )
    .then((response) => {
      store.dispatch({
        type: 'global/logoutUser',
      })
    })
    .catch((error) => {
      console.warn(error)
    })
})

const activation = computed(() => {
  return passwordReset.value.nonce !== ''
})

onMounted(() => {
  axios
    .post(
      '/api/v1/auth/logout',
      {
        user: {
          id: store.state.global.profileId,
          is_authenticated: store.state.global.is_authenticated,
        },
      },
      store.state.global.axiosConfig
    )
    .then((response) => {
      store.dispatch({
        type: 'global/logoutUser',
      })
    })
    .catch((error) => {
      console.warn(error)
    })
})

const passwordsMatch = computed(() => {
  if (
    passwordResetRequest.value.password1 ===
    passwordResetRequest.value.password2
  ) {
    return true
  } else {
    if (
      passwordResetRequest.value.password1 !== '' &&
      passwordResetRequest.value.password2 !== ''
    ) {
      errorMessage.value = i18n.global.t('models.auth.passwordNoMatch')
      return false
    } else {
      return true
    }
  }
})
</script>

<style lang="scss" scoped></style>
